import React from "react";

// One collapsible phase. Uses <details>/<summary> as the mockup does, so it
// stays keyboard accessible and works without JS for the open/close itself; the
// parent controls which one is open so the group behaves as an accordion.
const DispatchPhase = (props) => {
    const { number, name, subtitle, isOpen, onToggle, done, total, children } = props;
    const hasProgress = total > 0;
    const complete = hasProgress && done === total;

    return (
        <details className="phase" open={isOpen}>
            <summary
                onClick={(e) => {
                    // Drive open state from the parent rather than letting the
                    // browser toggle it, otherwise the accordion fights itself.
                    e.preventDefault();
                    onToggle(number);
                }}
            >
                <span className="ph-num">{number}</span>
                <span className="ph-txt">
                    <span className="ph-name">{name}</span>
                    <span className="ph-sub">{subtitle}</span>
                </span>
                {hasProgress && (
                    <span className={complete ? "ph-pill done" : "ph-pill"}>
                        {done}/{total}
                    </span>
                )}
                <span className="chev" aria-hidden="true">▾</span>
            </summary>
            <div className="phase-body">{children}</div>
        </details>
    );
};

export default DispatchPhase;
